<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "record",
  
})
</script>
<template>
    <van-popup class="channel-pop" v-model:show="showModal" position="bottom" close-on-popstate round :z-index="3001" @closed="handleClose">
        <!-- <Dialog v-model="showModal" :title="$t('Choose_currency')" v-bind="$attrs" @close="showModal = false" z-index="3001" lazy-render> -->
        <div class="wallet-bonus">
            <div class="title">
                {{ $t('Choose_currency') }}
                <div class="close" @click="handleClose"></div>
            </div>
            <div class="currency-wrap">
                <div class="currency-list">
                    <div
                        v-for="(item, index) in store.currencyList"
                        :key="item.currency"
                        :class="['currency-item', { active: idx === index }]"
                        @click="chooseItem(item, index)"
                    >
                        <div class="icon"><img :src="item.picture" /></div>
                        <p class="category">{{ item.currency }}</p>
                        <p class="balance">{{ formatNormalNumber(currencyConfig[item.currency] || 0) }}</p>
                    </div>
                </div>
                <div class="btn-wrap">
                    <Button type="submit" @confirm="onConfirm">{{ $t('Ok') }}</Button>
                </div>
            </div>
            <!-- </Dialog> -->
        </div>
    </van-popup>
</template>
<script lang="ts" setup name="record">
import Dialog from '@/components/dialog/Dialog.vue'
import Button from '@/components/Button.vue'
import { getCurrency, setCurrency } from '@/api'
import { useBaseStore } from '@/stores'
import { formatNormalNumber } from '@/utils/toolsValidate'

const store = useBaseStore()

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: () => false,
    },
    type: {
        // 1 确定是 发送请求设置货币， 2 不发送请求返回货币
        type: Number,
        default: () => 1,
    },
    default: {
        type: String,
        default: () => '',
    },
})
const emits = defineEmits(['update:modelValue', 'confirm', 'getData'])
const showModal = defineModel()
const idx = ref(0)
const confList = ref([])
const currencyConfig = ref({})
const chooseItem = (item, index) => {
    idx.value = index
}

const handleClose = () => {
    showModal.value = false
}
const onConfirm = () => {
    if (!~idx.value) {
        return
    }
    const currency = confList.value[idx.value].currency
    if (!currency) {
        return
    }
    try {
        if (props.type === 1) {
            if (props.default !== currency) {
                setCurrency(currency).then((res) => {
                    if (res.code === 200) {
                        store.setWallet(res.data.currency)
                        emits('confirm', res.data.currency)
                    }
                })
            }
        } else {
            emits('confirm', currency)
        }
    } finally {
        showModal.value = false
    }
}
function selectInit() {
    const currency = props.default || store.wallet?.currency || store.currencyList[0].currency
    const chekedIdx = store.currencyList.findIndex((item) => item.currency === currency)
    idx.value = chekedIdx
}
selectInit()
const getList = () => {
    getCurrency().then((res) => {
        if (res.code === 200) {
            const { confs = [], currencys = {} } = res.data
            currencyConfig.value = currencys
            emits('getData', confs)
            store.$patch({
                currencyList: confs,
            })
            confList.value = store.currencyList
            selectInit()
        }
    })
}

watch(showModal, () => {
    if (showModal.value) {
        selectInit()
        getList()
    }
})
const handleInitial = () => {
    confList.value = store.currencyList
}

onMounted(() => {
    handleInitial()
})
</script>
<style lang="scss" scoped>
.channel-pop {
    background-color: #2a2d3d;
}
.currency-wrap {
    display: flex;
    flex-direction: column;
    height: auto;
    max-height: 1000px;
}

.wallet-bonus {
    width: 750px;
    min-height: 692px;
    padding: 0 22px 58px;
    background-color: #232626;
    font-family: MicrosoftYaHei;
    color: #fff;

    .title {
        position: relative;
        @apply flex;
        padding-top: 33px;
        padding-bottom: 44px;
        position: relative;
        font-size: 52px;
        font-weight: bolder;

        &::before {
            display: inline-block;
            content: '';
            margin-right: 20px;

            width: 52px;
            height: 52px;
            background: url('@/assets/img/new-home/wallet-icon.png') no-repeat;
            background-size: 100% 100%;
            position: relative;
            top: 10px;
        }
        .close {
            position: absolute;
            right: 0px;
            top: 50px;
            width: 54px;
            height: 54px;
            background: url('@/assets/img/close.png') no-repeat center center;
            background-size: 27px 27px;
        }
    }
}
.btn-wrap {
    @apply flex align-top justify-center;
    position: relative;
    padding-top: 35px;
    height: 160px;
    text-align: center;

    :deep(.tiktoko.submit) {
        width: 540px;
        height: 100px;
        color: #000;
        font-size: 48px;
        // background-image: linear-gradient(90deg, #10c57f 0%, #0e8e66 100%), linear-gradient(#e59e20, #e59e20);
        // background-blend-mode: normal, normal;
        background-image: linear-gradient(90deg, #24ee89, #9fe871);
        box-shadow: 0 0 12px rgba(35, 238, 136, 0.3), inset 0 -4px #1dca6a;
        border-radius: 12px;
        border: none;
    }
}
.currency-list {
    flex: 1;
    padding: 0px 12px 0;
    .currency-item {
        display: flex;
        align-items: center;
        height: 118px;
        padding: 0 8px;
        margin: 10px 0;
        gap: 25px;
        border-radius: 20px;
        border: 4px solid rgb(58, 65, 66);
        font-size: 30px;
        font-weight: bold;
        letter-spacing: -1px;
        color: #fff;
        background-color: rgb(58, 65, 66);

        .icon {
            margin-left: 10px;
            width: 88px;
            height: 88px;
            //剧中
            display: flex;
            justify-content: center;
            align-items: center;

            img {
                width: 100%;
                height: auto;
            }
        }
        .category {
            flex: 1;
            margin-left: 10px;
        }
        .balance {
            margin-right: 25px;
        }
        &.active {
            position: relative;

            border-color: #10c580;

            &::after {
                position: absolute;
                right: -2px;
                bottom: -2px;
                display: inline-block;
                content: '';
                width: 52px;
                height: 52px;
                background: url('@/assets/img/wallets/checked.png') no-repeat;
                background-size: 100% 100%;
            }
        }
    }
    overflow: auto;
}
</style>
